// extracted by mini-css-extract-plugin
export default {"lntInputSearch":"styles_lnt-input-search__F22EH"};